export default __webpack_public_path__ + "static/media/whatsapp.a95195e1.svg";